<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center justify-content-between">
              <span class="section-title">LISTA DE PLANES DE EXTRACCIÓN</span>
              <argon-button color="warning" variant="gradient" size="sm" @click="$router.push({ name: 'Extraction Create' })">
                Agregar <i class="fa fa-plus"></i>
              </argon-button>
            </div>

            <!-- Filtros de búsqueda -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                  placeholder="Buscar extracción..." @input="fetchData(null)" />
              </div>

              <div class="col-md-3 mb-3">
                <label for="startDate" class="mb-1">Desde</label>
                <input type="date" v-model="startDate" id="startDate" class="form-control" @change="fetchData(null)" />
              </div>

              <div class="col-md-3 mb-3">
                <label for="endDate" class="mb-1">Hasta</label>
                <input type="date" v-model="endDate" id="endDate" class="form-control" @change="fetchData(null)" />
              </div>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-3">
                      Fecha de extracción
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Mina</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Cantidad extraída
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Calidad
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Humedad (%)
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Notas
                    </th>
                    <th class="text-secondary text-center text-uppercase text-xxs font-weight-bolder opacity-7">
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <!-- Fecha de extracción (sin conversión de zona horaria para que coincida con lo guardado) -->
                    <td class="align-middle text-start ps-3">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ formatExtractionDate(value.extraction_date) }}
                      </span>
                    </td>

                    <!-- Mina y Ubicación -->
                    <td class="ps-2">
                      <div class="d-flex py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <router-link :to="{ name: 'Extraction Create', params: { data: JSON.stringify(value) } }"
                            class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                            data-original-title="Editar Registro">
                            <h6 class="mb-0 text-sm">{{ value.mine.name }}</h6>
                          </router-link>
                          <p class="text-xs text-secondary mb-0">
                            Ubicación: {{ value.mine.location }}
                          </p>
                        </div>
                      </div>
                    </td>

                    <!-- Cantidad extraída -->
                    <td class="align-middle text-center text-sm">
                      {{ value.extracted_quantity }}
                    </td>

                    <!-- Calidad -->
                    <td class="align-middle text-center text-sm">
                      {{ value.quality_grade }}
                    </td>

                    <!-- Humedad -->
                    <td class="align-middle text-center text-sm">
                      {{ value.moisture_content }}
                    </td>

                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        <a @click="viewObservation(value.notes)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                          data-original-title="Registro">
                          <i class="fa fa-comment"></i>
                        </a>
                      </span>
                    </td>

                    <!-- Acciones -->
                    <td class="align-middle text-center">
                      <router-link :to="{ name: 'Extraction Create', params: { data: JSON.stringify(value) } }"
                        class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                        data-original-title="Editar Registro">
                        <i class="fa fa-pencil-alt"></i>
                      </router-link>

                      <a @click="deleteForm(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="9" class="text-center text-xxs">
                      No hay registros disponibles
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import ArgonButton from "../../../components/ArgonButton.vue";
export default {
  name: 'ProjectsTable',
  components: {
    ArgonButton,
  },
  data() {
    return {

      form: {
        id: 0,
        name: '',
        location: '',
        extraction_date: '',
        extracted_quantity: '',
        equipment_used: '',
        worker: '',
        quality: '',
        humidity: '',
        notes: ''
      },
      
      searchQuery: '', // Para el campo de búsqueda
      startDate: '',   // Para la fecha de inicio
      endDate: ''      // Para la fecha de fin
    };
  },
  computed: {

    ...mapGetters('minesExtractions', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']),
    currentPage() {
      return this.$store.state.minesExtractions.currentPage;
    },
    lastPage() {
      return this.$store.state.minesExtractions.lastPage;
    },
    data() {
      return this.allData;
    },
    links() {
      return this.$store.getters['minesExtractions/links'];
    },
  },
  methods: {
    // Mostrar fecha de extracción tal como se guardó (evita desfase por UTC)
    formatExtractionDate(dateStr) {
      if (!dateStr) return '—';
      const s = String(dateStr).slice(0, 10);
      if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return new Date(dateStr).toLocaleDateString('es-ES');
      const [y, m, d] = s.split('-');
      return `${parseInt(d, 10)}/${parseInt(m, 10)}/${y}`;
    },
    async fetchData(pageUrl = null) {

      const params = {
        search: this.searchQuery,
        start_date: this.startDate,
        end_date: this.endDate,
        page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
      };

      await this.$store.dispatch('minesExtractions/fetchData', params);
    },
    async deleteForm(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("minesExtractions/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            this.fetchData(null);

            await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el Empleado');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },

    // Método para mostrar la observación
    viewObservation(observation) {
      // Mostramos el mensaje en un SweetAlert
      Swal.fire({
        title: 'Notas',
        text: observation || 'No hay notas disponibles.',
        icon: 'info',  // Puedes cambiar el icono a info, success, warning, etc.
        confirmButtonText: 'Aceptar'
      });
    },
  },
  mounted() {
    this.fetchData(null);
  },
};

</script>

<style scoped>
.section-title {
  font-weight: 800;
  color: #1f2d5a;
  letter-spacing: 0.6px;
}

.section-title::after {
  content: "";
  display: block;
  width: 44px;
  height: 3px;
  margin-top: 6px;
  border-radius: 999px;
  background: #f6a500;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
  /* Estilo para la página activa */
}
</style>